<script lang="ts">
  import dayjs from 'dayjs';
  import { onMount, tick } from 'svelte';
  import { DatePicker } from '@svelte-plugins/datepicker';

  import { Input, GlobalListHOC } from '$shared/components';
  import { DateFormat } from '$provider/constants/Date';

  const dateValidateRegex = new RegExp(/\d{1,2}\/\d{1,2}\/\d{2,4}/); // Check for MM/DD/YYYY

  interface Props {
    disabled?: boolean;
    value?: string;
    error?: string;
    onchange?: (date: string) => void;
  }

  let { disabled = false, value = '', error = '', onchange }: Props = $props();

  let appWithList: GlobalListHOC = $state();
  let startDate = $state(new Date());
  let isOpen = $state(true);

  let date: string = $state('');

  onMount(() => {
    date = value;
    startDate = new Date(value);
  });

  const dispatchChange = (): void => {
    if (date && !dateValidateRegex.test(date)) return;

    onchange?.(date);
  };

  const toggleDatePicker = (): void => {
    isOpen = !isOpen;
    tick().then(() => {
      if (!isOpen) return;
      appWithList?.setListPosition();
    });
  };

  const formatDate = (detail: { value: string }): string => {
    let value = detail.value.replace(/\D/g, ''); // remove all non-digit characters

    if (value.length > 8) value = value.slice(0, 8); // limit to 8 digits

    if (value.length >= 5) {
      return value.replace(/(\d{2})(\d{2})(\d{1,4})/, '$1/$2/$3');
    }
    if (value.length >= 3) {
      return value.replace(/(\d{2})(\d{1,2})/, '$1/$2');
    }

    return value;
  };

  const onInputChange = (detail: { value: string }): void => {
    date = formatDate(detail);
    dispatchChange();
  };

  const onDateChange = (event: any): void => {
    date = dayjs(event.startDate).format(DateFormat.Default);
    dispatchChange();
  };
</script>

{#snippet labelSnippet()}
  <div class="date-input">
    <Input
      icon="icon-calendar"
      bind:value={date}
      {disabled}
      {error}
      placeholder={DateFormat.Default}
      onclickicon={toggleDatePicker}
      oninput={onInputChange}
    />
  </div>
{/snippet}

{#snippet listSnippet()}
  <div class="data-picker">
    <DatePicker bind:isOpen bind:startDate onDayClick={onDateChange} />
  </div>
{/snippet}

<div class="comp-date-picker">
  <GlobalListHOC
    autoAlign
    hasOverflow
    bind:this={appWithList}
    show={isOpen}
    label={labelSnippet}
    list={listSnippet}
  />
</div>

<style>
  .comp-date-picker .data-picker {
    height: 410px;
  }
</style>
